import React, { useState } from 'react';
// import WeeklySales from './WeeklySales';
import {
  // Row,
  Card,
  Tab,
  Nav
} from 'react-bootstrap';
// import {
//   marketShare,
//   totalOrder,
//   // totalSales,
//   weeklySalesData,
//   weather
//   // products,
//   // storageStatus,
//   // files,
//   // users,
//   // topProducts,
//   // runningProjects
// } from 'data/dashboard/default';

// import TotalOrder from './TotalOrder';
// import MarketShare from './MarketShare';
// import TotalSales from './TotalSales';
// import RunningProjects from './RunningProjects';
// import StorageStatus from './StorageStatus';
// import SpaceWarning from './SpaceWarning';
// import BestSellingProducts from './BestSellingProducts';
// import SharedFiles from './SharedFiles';
// import ActiveUsers from './ActiveUsers';
// import BandwidthSaved from './BandwidthSaved';
// import TopProducts from './TopProducts';
import PropTypes from 'prop-types';
// import Weather from './Weather';
import Audience from './audience/Audience';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import {
  getCredentialManagement,
  getCredentialManagementLocation,
  getCredentialManagementLocationRemainder,
  getCredentialManagementRemainder
} from 'nursd-dashboard/api/credentialManagement';
import { useEffect } from 'react';
import RecentLeads from './recent-leads/RecentLeads';
import RemainderTabs from './remainder/Audience';
import SimpleBarReact from 'simplebar-react';
import LMS from 'components/dashboards/lms/index';

const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState(undefined);
  const [dashboardRemainderData, setDashboardRemainderData] =
    useState(undefined);

  const [loadingScreen, setLoadingScreen] = useState(true);
  const [tableDetails, setTableDetails] = useState({
    title: '',
    view: false
  });

  const [loadingRemainderScreen, setLoadingRemainderScreen] = useState(true);

  const { authToken, location, organization } = useAuth();

  const getCredentialData = async () => {
    setLoadingScreen(true);
    try {
      const data = await getCredentialManagement(authToken);

      setDashboardData(data);
      setLoadingScreen(false);
    } catch (error) {
      setDashboardData([]);
      setLoadingScreen(false);
    }
  };

  const getCredentialDataLocation = async () => {
    setLoadingScreen(true);
    try {
      const data = await getCredentialManagementLocation(
        authToken,
        location,
        organization
      );

      setDashboardData(data);
      setLoadingScreen(false);
    } catch (error) {
      setDashboardData([]);
      setLoadingScreen(false);
    }
  };

  const getCredentialRemainderData = async () => {
    setLoadingRemainderScreen(true);
    try {
      const data = await getCredentialManagementRemainder(authToken);

      setDashboardRemainderData(data);
      setLoadingRemainderScreen(false);
    } catch (error) {
      setDashboardRemainderData([]);
      setLoadingRemainderScreen(false);
    }
  };

  const getCredentialRemainderDataLocation = async () => {
    setLoadingRemainderScreen(true);
    try {
      const data = await getCredentialManagementLocationRemainder(
        authToken,
        location,
        organization
      );

      setDashboardRemainderData(data);
      setLoadingRemainderScreen(false);
    } catch (error) {
      setDashboardRemainderData([]);
      setLoadingRemainderScreen(false);
    }
  };

  useEffect(() => {
    if (location !== '') {
      getCredentialDataLocation();
      getCredentialRemainderDataLocation();
    } else {
      getCredentialData();
      getCredentialRemainderData();
    }
  }, [authToken, location, organization]);
  // const saleItems = [ G
  //   {
  //     title: 'Orders',
  //     amount: '15,450',
  //     subAmount: '13,675',
  //     type: 'standard',
  //     percent: 21.8,
  //     className: 'border-200 border-bottom border-end pb-4'
  //   },
  //   {
  //     title: 'Items sold',
  //     amount: '1,054',
  //     subAmount: '13,675',
  //     type: 'warning',
  //     percent: 21.8,
  //     className:
  //       'border-200 border-md-200 border-bottom border-md-end pb-4 ps-3'
  //   },
  //   {
  //     title: 'Refunds',
  //     amount: '$145.65',
  //     subAmount: '13,675 ',
  //     type: 'up',
  //     percent: 21.8,
  //     className:
  //       'border-200 border-bottom border-end border-md-end-0 pb-4 pt-4 pt-md-0 ps-md-3'
  //   },
  //   {
  //     title: 'Gross sale',
  //     amount: '$100.26',
  //     subAmount: '$109.65 ',
  //     type: 'down',
  //     percent: 21.8,
  //     className:
  //       'border-200 border-md-200 border-bottom border-md-bottom-0 border-md-end pt-4 pb-md-0 ps-3 ps-md-0'
  //   },
  //   {
  //     title: 'Shipping',
  //     amount: '$365.53',
  //     subAmount: '13,675 ',
  //     type: 'up',
  //     percent: 21.8,
  //     className: 'border-200 border-md-bottom-0 border-end pt-4 pb-md-0 ps-md-3'
  //   },
  //   {
  //     title: 'Processing',
  //     amount: '861',
  //     subAmount: '13,675 ',
  //     type: 'pending',
  //     percent: 21.8,
  //     className: 'pb-0 pt-4 ps-3'
  //   }
  // ];

  const TabTitle = ({ title }) => (
    <div className="p-2 pe-4 text-start cursor-pointer">
      <h6 className="text-800 fs-8 text-nowrap">{title}</h6>
    </div>
  );

  TabTitle.propTypes = {
    title: PropTypes.string.isRequired
  };

  return (
    <>
      {loadingScreen ? (
        <Card>
          <p className="m-3">Loading...</p>
        </Card>
      ) : (
        <>
          <Tab.Container id="audience-tab" defaultActiveKey="Credentials">
            <SimpleBarReact>
              <Card.Header className="p-0 bg-body-tertiary">
                <Nav className="nav-tabs border-0 flex-nowrap chart-tab">
                  <Nav.Item>
                    <Nav.Link className="mb-0" eventKey="Credentials">
                      <TabTitle title="Credentials" />
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link className="mb-0" eventKey="LMS">
                      <TabTitle title="Trainings" />
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </Card.Header>
            </SimpleBarReact>

            <Card.Body>
              <Tab.Content>
                <Tab.Pane unmountOnExit eventKey="Credentials">
                  {/* <Row className="g-3 mb-3 mt-2">
                    <Col md={3} xxl={3}>
                      <WeeklySales data={weeklySalesData} />
                    </Col>
                    <Col md={3} xxl={3}>
                      <TotalOrder data={totalOrder} />
                    </Col>
                    <Col md={3} xxl={3}>
                      <MarketShare
                        data={marketShare}
                        radius={['100%', '87%']}
                      />
                    </Col>
                    <Col md={3} xxl={3}>
                      <Weather data={weather} />
                    </Col>
                  </Row> */}
                  <Audience
                    className="my-3"
                    data={dashboardData}
                    setTableDetails={setTableDetails}
                  />
                  {tableDetails.view && (
                    <RecentLeads
                      data={dashboardData}
                      tableDetails={tableDetails}
                      setTableDetails={setTableDetails}
                    />
                  )}
                  {loadingRemainderScreen ? (
                    <Card>
                      <p className="m-3">Loading...</p>
                    </Card>
                  ) : (
                    <RemainderTabs
                      className="mb-3"
                      data={dashboardRemainderData}
                    />
                  )}
                </Tab.Pane>
                <Tab.Pane unmountOnExit eventKey="LMS">
                  <div className="mt-3">
                    <LMS />
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Card.Body>
          </Tab.Container>

          {/* <Row className="g-3 mb-3">
            <Col lg={6}>
              <RunningProjects data={runningProjects} />
            </Col>
            <Col lg={6}>
              <TotalSales data={totalSales} />
            </Col>
          </Row>

          <Row className="g-3 mb-3">
            <Col lg={6} xl={7} xxl={8}>
              <StorageStatus className="h-lg-100" data={storageStatus} />
            </Col>
            <Col lg={6} xl={5} xxl={4}>
              <SpaceWarning />
            </Col>
          </Row>

          <Row className="g-3 mb-3">
            <Col lg={7} xl={8}>
              <BestSellingProducts products={products} />
            </Col>
            <Col lg={5} xl={4}>
              <SharedFiles files={files} className="h-lg-100" />
            </Col>
          </Row>

          <Row className="g-3">
            <Col sm={6} xxl={3}>
              <ActiveUsers className="h-100" users={users} />
            </Col>
            <Col sm={6} xxl={3} className="order-xxl-1">
              <BandwidthSaved />
            </Col>
            <Col xxl={6}>
              <TopProducts data={topProducts} className="h-100" />
            </Col>
          </Row> */}
        </>
      )}
    </>
  );
};

export default Dashboard;
